import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaGraduationCap, 
  FaUniversity, 
  FaSearch, 
  FaFileAlt, 
  FaComments,
  FaCheckCircle,
  FaWhatsapp,
  FaBookOpen,
  FaChartLine,
  FaStar,
  FaQuoteLeft,
  FaGlobe,
  FaCalendarAlt,
  FaUserGraduate,
  FaMedal,
  FaRocket,
  FaPhoneAlt,
  FaChevronRight,
  FaHeart,
  FaHandshake,
  FaBuilding,
  FaLaptopCode,
  FaChalkboardTeacher
} from 'react-icons/fa';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './AdmissionUniversitaire.css';

const AdmissionUniversitaire = () => {
  const [activeFaq, setActiveFaq] = useState(null);

  const universities = [
    { name: "INSEEC", location: "Paris, Bordeaux, Lyon", type: "École de commerce", rating: 4.7 },
    { name: "ESCE", location: "Paris, Lyon", type: "École de commerce", rating: 4.6 },
    { name: "EBS Paris", location: "Paris", type: "École de commerce", rating: 4.5 },
    { name: "ECE Paris", location: "Paris", type: "École d'ingénieurs", rating: 4.7 },
    { name: "SUP DE PUB", location: "Paris, Lyon, Bordeaux", type: "École de communication", rating: 4.5 },
    { name: "HEIP", location: "Paris", type: "École de relations internationales", rating: 4.6 },
    { name: "Ascensia", location: "Paris", type: "École de management", rating: 4.4 },
    { name: "KEYCE", location: "Paris, Lyon", type: "École de commerce", rating: 4.5 },
    { name: "ESTIAM", location: "Paris", type: "École d'informatique", rating: 4.6 },
    { name: "DIGITAL COLLEGE", location: "Paris, Lyon, Bordeaux", type: "École du numérique", rating: 4.4 },
    { name: "ECOLE CONTE", location: "Paris, Lyon, Toulouse", type: "École d'art et design", rating: 4.5 },
    { name: "KEDGE Business School", location: "Bordeaux, Marseille, Paris", type: "Grande école", rating: 4.8 },
    { name: "CY Tech", location: "Cergy", type: "École d'ingénieurs", rating: 4.6 },
    { name: "Y SCHOOLS", location: "Paris", type: "École de management", rating: 4.4 },
    { name: "IMCP", location: "Paris", type: "École de psychologie", rating: 4.5 },
    { name: "SUP ECOLIDAIRE", location: "Paris", type: "École solidaire", rating: 4.6 }
  ];

  const steps = [
    {
      id: 1,
      title: "Bilan de parcours",
      description: "Analyse approfondie de votre profil académique et professionnel",
      icon: <FaSearch />,
      details: "Évaluation personnalisée de votre dossier",
      color: "#dc143c"
    },
    {
      id: 2,
      title: "Sélection des formations",
      description: "Choix stratégique des universités et programmes adaptés à votre profil",
      icon: <FaUniversity />,
      details: "Accès à 60+ universités partenaires",
      color: "#2a5298"
    },
    {
      id: 3,
      title: "Préparation du dossier",
      description: "Rédaction et optimisation des CV, lettres de motivation et documents requis",
      icon: <FaFileAlt />,
      details: "Relecture par des experts",
      color: "#1e3c72"
    },
    {
      id: 4,
      title: "Suivi des candidatures",
      description: "Accompagnement jusqu'à l'obtention de l'admission définitive",
      icon: <FaCheckCircle />,
      details: "Suivi en temps réel",
      color: "#dc143c"
    }
  ];

  const benefits = [
    { icon: <FaCheckCircle />, title: "Accès exclusif à 60+ universités partenaires", desc: "Réseau privilégié d'établissements" },
    { icon: <FaChartLine />, title: "Taux d'admission supérieur à 85%", desc: "Résultats prouvés et vérifiés" },
    { icon: <FaUserGraduate />, title: "Accompagnement personnalisé", desc: "Experts dédiés à votre dossier" },
    { icon: <FaComments />, title: "Préparation aux entretiens", desc: "Simulations et coaching intensif" },
    { icon: <FaFileAlt />, title: "Optimisation du dossier académique", desc: "Mise en valeur de vos compétences" },
    { icon: <FaGlobe />, title: "Suivi en temps réel", desc: "Plateforme de suivi des candidatures" }
  ];

  const successStories = [
    {
      name: "Marie K.",
      country: "Cameroun",
      university: "KEDGE Business School",
      program: "Master en Finance",
      quote: "Grâce à l'accompagnement d'ETEF, j'ai été admise à KEDGE Business School. L'équipe a été d'un professionnalisme exceptionnel !",
      rating: 5
    },
    {
      name: "Thomas D.",
      country: "Maroc",
      university: "ECE Paris",
      program: "Bachelor en Informatique",
      quote: "Leur expertise m'a permis d'intégrer ECE Paris. Les simulations d'entretien ont fait toute la différence.",
      rating: 5
    },
    {
      name: "Amina B.",
      country: "Algérie",
      university: "INSEEC",
      program: "Master en Marketing",
      quote: "Service impeccable, réactif et très professionnel. Je recommande vivement leurs services !",
      rating: 5
    }
  ];

  const faqs = [
    {
      q: "Quel est le délai pour obtenir une admission ?",
      a: "Le délai varie selon les universités et les programmes. En moyenne, comptez 2 à 4 mois entre le dépôt du dossier et la réponse. Nous optimisons ce délai grâce à notre réseau de partenaires."
    },
    {
      q: "Quels sont les prérequis pour intégrer une université française ?",
      a: "Les prérequis dépendent du niveau d'études : Licence (Bac), Master (Licence), Doctorat (Master). Une bonne maîtrise du français (B2 minimum) est généralement requise, sauf pour les programmes en anglais."
    },
    {
      q: "Proposez-vous une aide pour les tests de langue ?",
      a: "Oui, nous proposons une préparation complète aux tests de français (DELF, DALF, TCF) et d'anglais (TOEFL, IELTS) avec des ressources et des exercices pratiques."
    },
    {
      q: "Comment se passe l'accompagnement pour les écoles de commerce ?",
      a: "Nous proposons un accompagnement spécifique pour les écoles de commerce : préparation aux tests (TAGE MAGE, GMAT, TOEIC), coaching pour les entretiens de motivation et optimisation du dossier."
    },
    {
      q: "Quels sont vos tarifs ?",
      a: "Nos forfaits d'accompagnement commencent à 390€ TTC. Nous proposons également des options personnalisées selon vos besoins. Contactez-nous pour un devis gratuit sans engagement."
    },
    {
      q: "Proposez-vous une aide pour le logement étudiant ?",
      a: "Oui, nous accompagnons nos étudiants dans la recherche de logement en France et les aidons à constituer les dossiers nécessaires pour les résidences étudiantes."
    }
  ];

  const programs = [
    { name: "Licence", duration: "3 ans", level: "Baccalauréat", icon: <FaGraduationCap /> },
    { name: "Bachelor", duration: "3 ans", level: "Baccalauréat", icon: <FaBookOpen /> },
    { name: "Master", duration: "2 ans", level: "Licence", icon: <FaUserGraduate /> },
    { name: "MBA", duration: "1-2 ans", level: "Bachelor + expérience", icon: <FaChartLine /> },
    { name: "Programmes internationaux", duration: "Variable", level: "Anglais requis", icon: <FaGlobe /> }
  ];

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <div className="admission-service-page">
      <Header />
      
      {/* Hero Section with Animated Background */}
      <section className="admission-hero">
        <div className="admission-hero-bg">
          <div className="admission-hero-bg-gradient"></div>
          <div className="admission-hero-bg-particles"></div>
        </div>
        <div className="admission-hero-container">
          <div className="admission-hero-content">
            <div className="admission-badge">
              <FaMedal /> Excellence académique
            </div>
            <h1>Admission <span className="admission-gradient-text">Universitaires</span> en France</h1>
            <p>Accédez aux meilleures formations dans plus de 60 universités partenaires. Un accompagnement personnalisé pour intégrer l'établissement de vos rêves.</p>
            <div className="admission-hero-actions">
              <Link to="/contact" className="admission-btn-primary">
                <FaRocket /> Démarrer mon admission
              </Link>
              <Link to="/universites-partenaires" className="admission-btn-outline">
                <FaUniversity /> Voir les universités
              </Link>
              <a href="https://wa.me/33695744027" className="admission-btn-whatsapp-hero">
                <FaWhatsapp /> Consultation gratuite
              </a>
            </div>
            <div className="admission-hero-stats">
              <div className="admission-stat-item">
                <strong>60+</strong>
                <span>Universités partenaires</span>
              </div>
              <div className="admission-stat-divider"></div>
              <div className="admission-stat-item">
                <strong>85%</strong>
                <span>Taux d'admission</span>
              </div>
              <div className="admission-stat-divider"></div>
              <div className="admission-stat-item">
                <strong>200+</strong>
                <span>Formations disponibles</span>
              </div>
              <div className="admission-stat-divider"></div>
              <div className="admission-stat-item">
                <strong>98%</strong>
                <span>Clients satisfaits</span>
              </div>
            </div>
          </div>
        </div>
        <div className="admission-hero-wave">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>
      </section>

      {/* Programs Section */}
      <section className="admission-programs">
        <div className="admission-container">
          <div className="admission-section-header">
            <h2>Formations proposées</h2>
            <p>Des programmes adaptés à tous les niveaux d'études</p>
          </div>
          <div className="admission-programs-grid">
            {programs.map((program, index) => (
              <div key={index} className="admission-program-card">
                <div className="admission-program-icon-wrapper">
                  {program.icon}
                </div>
                <h3>{program.name}</h3>
                <p>Durée: {program.duration}</p>
                <span className="admission-program-level">Prérequis: {program.level}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="admission-process">
        <div className="admission-container">
          <div className="admission-section-header">
            <h2>Notre processus d'accompagnement</h2>
            <p>Une méthode éprouvée en 4 étapes pour maximiser vos chances d'admission</p>
          </div>
          <div className="admission-steps-grid">
            {steps.map((step) => (
              <div key={step.id} className="admission-step-card">
                <div className="admission-step-number" style={{ background: step.color }}>{step.id}</div>
                <div className="admission-step-icon-wrapper" style={{ color: step.color }}>
                  {step.icon}
                </div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
                <span className="admission-step-detail">{step.details}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Universities Section - Updated with new universities */}
      <section className="admission-universities">
        <div className="admission-container">
          <div className="admission-section-header">
            <h2>Nos universités partenaires</h2>
            <p>Un réseau d'excellence pour votre réussite académique</p>
          </div>
          <div className="admission-universities-grid">
            {universities.map((uni, index) => (
              <div key={index} className="admission-uni-card">
                <div className="admission-uni-icon-wrapper">
                  <FaUniversity />
                </div>
                <h3>{uni.name}</h3>
                <p className="admission-uni-location">{uni.location}</p>
                <div className="admission-uni-rating">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} className={i < Math.floor(uni.rating) ? 'filled' : 'empty'} />
                  ))}
                  <span>{uni.rating}</span>
                </div>
                <div className="admission-uni-tags">
                  <span className="admission-tag">{uni.type}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="admission-more-universities">
            <Link to="/universites-partenaires" className="admission-link-more">
              Voir toutes les universités partenaires <FaChevronRight />
            </Link>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="admission-benefits">
        <div className="admission-container">
          <div className="admission-section-header">
            <h2>Pourquoi choisir notre service ?</h2>
            <p>Des avantages exclusifs pour votre parcours académique</p>
          </div>
          <div className="admission-benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="admission-benefit-card">
                <div className="admission-benefit-icon-wrapper">
                  {benefit.icon}
                </div>
                <h4>{benefit.title}</h4>
                <p>{benefit.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="admission-testimonials">
        <div className="admission-container">
          <div className="admission-section-header">
            <h2>Témoignages de <span className="admission-gradient-text">réussite</span></h2>
            <p>Des étudiants qui ont réalisé leur rêve grâce à notre accompagnement</p>
          </div>
          <div className="admission-testimonials-grid">
            {successStories.map((story, index) => (
              <div key={index} className="admission-testimonial-card">
                <div className="admission-testimonial-header">
                  <div className="admission-testimonial-avatar">
                    <FaUserGraduate />
                  </div>
                  <div className="admission-testimonial-rating">
                    {[...Array(story.rating)].map((_, i) => (
                      <FaStar key={i} />
                    ))}
                  </div>
                </div>
                <div className="admission-testimonial-quote-icon">
                  <FaQuoteLeft />
                </div>
                <p className="admission-testimonial-quote">"{story.quote}"</p>
                <div className="admission-testimonial-author">
                  <h4>{story.name}</h4>
                  <p>{story.country}</p>
                  <div className="admission-testimonial-university">
                    <FaUniversity />
                    <span>{story.university}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section with Accordion */}
      <section className="admission-faq">
        <div className="admission-container">
          <div className="admission-section-header">
            <h2>Questions <span className="admission-gradient-text">fréquentes</span></h2>
            <p>Tout ce que vous devez savoir sur l'admission universitaire</p>
          </div>
          <div className="admission-faq-grid">
            {faqs.map((faq, index) => (
              <div key={index} className="admission-faq-item">
                <button className="admission-faq-question" onClick={() => toggleFaq(index)}>
                  <span>{faq.q}</span>
                  <FaChevronRight className={`admission-faq-icon ${activeFaq === index ? 'rotated' : ''}`} />
                </button>
                <div className={`admission-faq-answer ${activeFaq === index ? 'active' : ''}`}>
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="admission-cta">
        <div className="admission-container">
          <div className="admission-cta-wrapper">
            <div className="admission-cta-content">
              <h2>Prêt à intégrer l'université <br/>de vos rêves ?</h2>
              <p>Bénéficiez d'un premier conseil gratuit avec nos experts en admission universitaire</p>
              <div className="admission-cta-buttons">
                <Link to="/contact" className="admission-btn-cta-primary">
                  <FaCalendarAlt /> Réserver mon conseil gratuit
                </Link>
                <a href="https://wa.me/33695744027" className="admission-btn-cta-whatsapp">
                  <FaWhatsapp /> Discuter sur WhatsApp
                </a>
              </div>
              <div className="admission-cta-note">
                <FaHeart /> Sans engagement, première consultation offerte
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AdmissionUniversitaire;